import { AccordionItem } from "@/components";

/** FAQ items for the right column of the billing overview. */
export const billingFaqItems: AccordionItem[] = [
	{
		id: "update-payment",
		title: "How can I update my payment method?",
		content: (
			<p>
				You can update your payment method directly in the Signalist Billing Portal powered by
				Stripe. Go to <strong>Settings → Billing → Manage Subscription</strong>, and Stripe will let
				you add, remove, or change your card or payment method.
			</p>
		),
	},
	{
		id: "download-invoices",
		title: "How can I download my invoices?",
		content: (
			<p>
				All invoices are available in your Stripe Billing Portal under{" "}
				<strong>Invoice History</strong>.
			</p>
		),
	},
	{
		id: "company-invoice",
		title: "Can I get an invoice with my company details (VAT ID, address, etc)?",
		content: (
			<p>
				Yes. In Stripe Billing Portal – <strong>Billing Information</strong>, update company name,
				VAT ID, and address.
			</p>
		),
	},
	{
		id: "billing-email",
		title: "How do I change my billing email?",
		content: (
			<p>
				Update it inside the Stripe Billing Portal under <strong>Customer Information</strong>.
			</p>
		),
	},
	{
		id: "change-plan",
		title: "How do I change my subscription plan?",
		content: (
			<p>
				Click the <strong>Change plan</strong> button above or go to{" "}
				<strong>Manage Subscription</strong> in the Stripe portal to upgrade or downgrade your plan.
			</p>
		),
	},
	{
		id: "cancel-subscription",
		title: "How can I cancel my subscription?",
		content: (
			<p>
				Click the <strong>Cancel Subscription</strong> button above, next to your current plan. Your
				access will continue until the end of your current billing period. You can also cancel in
				the Stripe Billing Portal.
			</p>
		),
	},
	{
		id: "cancel-trial",
		title: "How can I cancel during my trial?",
		content: (
			<p>
				The same <strong>Cancel Subscription</strong> button is available while you are in your
				trial. Cancelling during the trial ends your subscription when the trial ends and{" "}
				<strong>no payment is taken</strong>. You keep full trial access until then, and you can
				undo it with <strong>Reactivate Subscription</strong> as long as the trial is still running.
			</p>
		),
	},
	{
		id: "after-cancel",
		title: "What happens after I cancel?",
		content: (
			<p>
				After cancellation, you&apos;ll retain access until the end of your billing period. Your
				data will be preserved for 30 days, after which it may be deleted.
			</p>
		),
	},
	{
		id: "refund",
		title: "Can I request a refund?",
		content: (
			<p>
				Please contact <strong>support@signalist.io</strong> for refund requests. We handle these on
				a case-by-case basis.
			</p>
		),
	},
	{
		id: "add-credits",
		title: "How do I add funds / credits to my account?",
		content: (
			<p>
				Click the <strong>Add more credits</strong> button above or contact support to purchase
				additional credits.
			</p>
		),
	},
	{
		id: "rollover-credits",
		title: "How do rollover credits work?",
		content: <p>Rollover credits are unused credits from your previous billing cycle.</p>,
	},
	{
		id: "trial-credits",
		title: "Why do I have fewer credits during my trial?",
		content: (
			<p>
				During your trial period, you receive a limited number of credits to test the platform. Once
				your trial ends and your subscription becomes active, you will receive the full credit
				amount included in your plan. You can skip the trial at any time by clicking the{" "}
				<strong>Skip Trial</strong> button to start your subscription immediately and get access to
				all your credits.
			</p>
		),
	},
];
